<template>
  <div
    tabindex="0"
    class="button-cont"
    :class="{
      blue: buttonName === 'base',
      green: buttonName === 'prevYear1',
      pink: buttonName === 'prevYear2',
      orange: buttonName === 'prevYear3',
      whiteText: selectedButton === true,
      blueBG: buttonName === 'base' && selectedButton === true,
      greenBG: buttonName === 'prevYear1' && selectedButton === true,
      pinkBG: buttonName === 'prevYear2' && selectedButton === true,
      orangeBG: buttonName === 'prevYear3' && selectedButton === true,
    }"
    @click="clicked(buttonName)"
    @keypress="clicked(buttonName)"
  >
    <div class="fromLabel">
      {{ labelFrom }}
    </div>
    <div class="toLabel">
      {{ labelTo }}
    </div>
    <div
      class="arrow"
      :class="{
        'triangle-up': arrow === false,
        'triangle-down': arrow === true,
        whiteTriangle: selectedButton === true,
        blueTriangle: buttonName === 'base',
        greenTriangle: buttonName === 'prevYear1',
        pinkTriangle: buttonName === 'prevYear2',
        orangeTriangle: buttonName === 'prevYear3',
      }"
    />
  </div>
</template>

<script>
export default {
  name: 'Rare3YOYsortButton',
  props: {
    buttonName: {
      type: String,
      required: false,
      default: '',
    },
    labelFrom: {
      type: String,
      required: false,
      default: '',
    },
    labelTo: {
      type: String,
      required: false,
      default: '',
    },
  },
  data() {
    return {
    };
  },
  computed: {
    rareMode() {
      return (this.$store.getters.clientOrRareMode === 'rare');
    },
    selectedButton() {
      let returnValue = false;
      if (this.tableSortColumn === this.buttonName) {
        returnValue = true;
      }
      return returnValue;
    },
    tableSortColumn() {
      return this.$store.getters.tableSortColumn;
    },
    currentColor() {
      return this.$store.getters.fetchTableTextColor(this.tableSortColumn);
    },
    arrow() {
      let returnValue = true;
      if (this.tableSortColumn === this.buttonName) {
        returnValue = false;
      }
      return returnValue;
    },
  },
  methods: {
    clicked(sortColumn) {
      /* TO DO: make sure this can handle sorting of tables across views/
      modules as this is potentially trying to committing a mutation to the
      global store when it is now modular */
      this.$store.commit('updateTableSortColumn', sortColumn);
      this.$root.$emit('updateCharts');
    },
  },
};
</script>

<style lang="scss" scoped>

@import "~@/css/global.scss";

  .button-cont {
    width: 160px;
    height: 60px;
    border-radius: 30px;
    display: block;
    border: 1px solid;
    position: relative;
    margin: 20px auto 0 auto;
    font-size: 14px;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.43;
    letter-spacing: 1px;
    cursor: pointer;
  }

  .triangle-down {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 8px solid;
  }

  .triangle-up {
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-bottom: 8px solid;
  }
  .blueTriangle {
    border-top-color: $graph-blue-text;
  }

  .greenTriangle {
    border-top-color: $graph-green-text;
  }

  .pinkTriangle {
    border-top-color: $graph-pink-text;
  }

  .orangeTriangle {
    border-top-color: $graph-orange-text;
  }

  .whiteTriangle {
    border-top-color: #ffffff !important;
  }

  .blueBG {
    background-color: $graph-blue-text;
  }

  .greenBG {
    background-color: $graph-green-text;
  }

  .pinkBG {
    background-color: $graph-pink-text;
  }

  .orangeBG {
    background-color: $graph-orange-text;
  }

  .blue {
    color: $graph-blue-text;
    border-color: $graph-blue-text;
  }

.green {
      color: $graph-green-text;
      border-color: $graph-green-text;
    }

  .pink {
    color: $graph-pink-text;
    border-color: $graph-pink-text;
  }

  .orange {
    color: $graph-orange-text;
    border-color: $graph-orange-text;
  }

  .whiteText {
    color: #ffffff !important;
  }

.fromLabel {
    position: absolute;
    left: 20px;
    top: 9px;
    color: inherit;
  }

  .toLabel {
    position: absolute;
    left: 20px;
    top: 29px;
    color: inherit;
  }

  .arrow {
    position: absolute;
    left: 129px;
    top: 25px;
    color: inherit;
  }

</style>
